export const InviteList = ({ invites = [] }) => {
  if (!invites.length) return null;
  return (
    <div className="space-y-2">
      <div className="lf-label">Your invites</div>
      <ul className="divide-y divide-[#2D3442] rounded-md border border-[#2D3442]" data-testid="invite-list">
        {invites.map((i) => (
          <li key={i.id} className="flex items-center justify-between gap-3 px-3 py-2 text-sm" data-testid={`invite-row-${i.email}`}>
            <span className="truncate text-[#D6CCBC]">{i.email}</span>
            <span className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] uppercase tracking-widest ${i.status === "joined" ? "bg-[#10B981]/15 text-[#34D399]" : "bg-[#2D3442] text-[#A8A090]"}`}
              data-testid={`invite-status-${i.email}`}>{i.status === "joined" ? "Joined" : "Pending"}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
